module.exports = __webpack_public_path__ + "static/socialmediabranding-1b0b3b6c9481ef40218f7321cd314d77.jpg";